/* ELEGANT STYLE — Carrito y checkout solo-WhatsApp (reemplaza el carrito nativo de Shopify) */
(function () {
  'use strict';
  var CFG = window.ECConfig || { whatsapp: '51916679633', tienda: 'ELEGANT STYLE', moneda: 'S/' };
  var LS_KEY = 'ec_cart_v1';
  var UBIGEO = null;
  var ubigeoPromise = null;

  function fmt(n) { return CFG.moneda + ' ' + (Math.round(n * 100) / 100).toFixed(2); }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function getCart() {
    try { return JSON.parse(localStorage.getItem(LS_KEY)) || []; } catch (e) { return []; }
  }
  function saveCart(cart) {
    localStorage.setItem(LS_KEY, JSON.stringify(cart));
    renderBadge();
  }
  function cartKey(handle, color, talla) { return handle + '::' + (color || '') + '::' + (talla || ''); }

  function tierFor(tiers, qty) {
    if (!tiers || !tiers.length) return null;
    var t = tiers[0];
    for (var i = 0; i < tiers.length; i++) { if (qty >= tiers[i].qty) t = tiers[i]; }
    return t;
  }

  function cartLines() {
    var cart = getCart();
    var totalsByHandle = {};
    cart.forEach(function (l) { totalsByHandle[l.handle] = (totalsByHandle[l.handle] || 0) + l.qty; });
    return cart.map(function (line) {
      var aggQty = totalsByHandle[line.handle] || line.qty;
      var tier = tierFor(line.tiers, aggQty);
      var basePrice = line.tiers && line.tiers.length ? line.tiers[0].price : line.price;
      var unitPrice = (tier ? tier.price : line.price) + (line.sizeExtra || 0);
      var lineTotal = unitPrice * line.qty;
      var refTotal = (basePrice + (line.sizeExtra || 0)) * line.qty;
      var saving = Math.max(0, refTotal - lineTotal);
      return Object.assign({}, line, { unitPrice: unitPrice, lineTotal: lineTotal, saving: saving, aggQty: aggQty });
    });
  }

  function cartTotal() { return cartLines().reduce(function (s, l) { return s + l.lineTotal; }, 0); }
  function cartSavings() { return cartLines().reduce(function (s, l) { return s + l.saving; }, 0); }
  function cartUnitCount() { return getCart().reduce(function (s, l) { return s + l.qty; }, 0); }

  function addToCart(item) {
    var cart = getCart();
    var key = cartKey(item.handle, item.colorName, item.talla);
    var existing = cart.find(function (l) { return l.key === key; });
    if (existing) { existing.qty += item.qty; }
    else { item.key = key; cart.push(item); }
    saveCart(cart);
  }
  function removeLine(key) {
    saveCart(getCart().filter(function (l) { return l.key !== key; }));
    renderDrawer();
  }
  function setLineQty(key, qty) {
    var cart = getCart();
    var l = cart.find(function (x) { return x.key === key; });
    if (!l) return;
    if (qty <= 0) { cart = cart.filter(function (x) { return x.key !== key; }); }
    else { l.qty = qty; }
    saveCart(cart);
    renderDrawer();
  }
  function clearCart() { saveCart([]); }

  function renderBadge() {
    var n = cartUnitCount();
    document.querySelectorAll('[data-ec-cart-badge]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  function el(id) { return document.getElementById(id); }

  function renderDrawer() {
    var body = el('ec-cart-body');
    if (!body) return;
    var lines = cartLines();
    if (!lines.length) {
      body.innerHTML = '<p class="ec-empty">Tu carrito está vacío.</p>';
    } else {
      body.innerHTML = lines.map(function (l) {
        return '' +
          '<div class="ec-cart-line">' +
          '<img src="' + esc(l.img || '') + '" alt="" class="ec-cart-thumb">' +
          '<div class="ec-cart-info">' +
          '<div class="ec-cart-title">' + esc(l.productTitle) + '</div>' +
          '<div class="ec-cart-sub">' + esc(l.colorName || '') + (l.talla ? ' · Talla ' + esc(l.talla) : '') + '</div>' +
          '<div class="ec-cart-qtyrow">' +
          '<button class="ec-qtybtn" data-ec-action="cart-dec" data-key="' + esc(l.key) + '">−</button>' +
          '<span>' + l.qty + '</span>' +
          '<button class="ec-qtybtn" data-ec-action="cart-inc" data-key="' + esc(l.key) + '">+</button>' +
          '<button class="ec-remove" data-ec-action="cart-remove" data-key="' + esc(l.key) + '">Quitar</button>' +
          '</div></div>' +
          '<div class="ec-cart-price">' + fmt(l.lineTotal) + '</div>' +
          '</div>';
      }).join('');
    }
    var savings = cartSavings();
    el('ec-cart-savings').innerHTML = savings > 0 ? '🎉 Ahorro por cantidad: ' + fmt(savings) : '';
    el('ec-cart-total').textContent = fmt(cartTotal());
  }

  function openDrawer() { renderDrawer(); el('ec-cart-drawer').classList.add('ec-open'); document.body.classList.add('ec-noscroll'); }
  function closeDrawer() { el('ec-cart-drawer').classList.remove('ec-open'); document.body.classList.remove('ec-noscroll'); }

  /* ---------- Ubigeo ---------- */
  function loadUbigeo() {
    if (ubigeoPromise) return ubigeoPromise;
    ubigeoPromise = fetch(CFG.ubigeoUrl).then(function (r) { return r.json(); }).then(function (data) { UBIGEO = data; return data; });
    return ubigeoPromise;
  }
  function fillSelect(sel, options, placeholder) {
    sel.innerHTML = '<option value="">' + placeholder + '</option>' + options.map(function (o) { return '<option value="' + esc(o) + '">' + esc(o) + '</option>'; }).join('');
    sel.disabled = options.length === 0;
  }
  function initUbigeoForm() {
    loadUbigeo().then(function (data) {
      var selDept = el('ec-dept'), selProv = el('ec-prov'), selDist = el('ec-dist');
      if (!selDept) return;
      fillSelect(selDept, Object.keys(data), 'Selecciona departamento');
      fillSelect(selProv, [], 'Selecciona provincia');
      fillSelect(selDist, [], 'Selecciona distrito');
      selDept.onchange = function () {
        var provs = data[selDept.value] ? Object.keys(data[selDept.value]) : [];
        fillSelect(selProv, provs, 'Selecciona provincia');
        fillSelect(selDist, [], 'Selecciona distrito');
      };
      selProv.onchange = function () {
        var dists = (data[selDept.value] && data[selDept.value][selProv.value]) || [];
        fillSelect(selDist, dists, 'Selecciona distrito');
      };
    });
  }

  /* ---------- Shipping modal / checkout ---------- */
  function orderSummaryHTML() {
    var lines = cartLines();
    if (!lines.length) return '<p class="ec-empty">No hay productos seleccionados.</p>';
    var totalUnits = lines.reduce(function (s, l) { return s + l.qty; }, 0);
    var savings = cartSavings();
    return '' +
      '<div class="ec-summary">' +
      '<div class="ec-summary-head">🧾 Tu pedido (' + totalUnits + ' und)</div>' +
      '<div class="ec-summary-items">' + lines.map(function (l) {
        return '<div class="ec-summary-item">' +
          '<img src="' + esc(l.img || '') + '" class="ec-summary-thumb">' +
          '<div class="ec-summary-info">' +
          '<div class="ec-summary-title">' + esc(l.productTitle) + '</div>' +
          '<div class="ec-summary-sub">' + esc(l.colorName || '') + (l.talla ? ' · Talla ' + esc(l.talla) : '') + '</div>' +
          '<div class="ec-summary-sub">' + l.qty + ' und x ' + fmt(l.unitPrice) + '</div>' +
          '</div>' +
          '<div class="ec-summary-lineTotal">' + fmt(l.lineTotal) + '</div>' +
          '</div>';
      }).join('') + '</div>' +
      (savings > 0 ? '<div class="ec-summary-savings">🎉 Ahorro por cantidad: ' + fmt(savings) + '</div>' : '') +
      '<div class="ec-summary-total"><span>Total</span><span>' + fmt(cartTotal()) + '</span></div>' +
      '</div>';
  }

  function openShipping() {
    closeDrawer();
    el('ec-shipping-summary').innerHTML = orderSummaryHTML();
    el('ec-shipping-modal').classList.add('ec-open');
    document.body.classList.add('ec-noscroll');
    initUbigeoForm();
  }
  function closeShipping() {
    el('ec-shipping-modal').classList.remove('ec-open');
    document.body.classList.remove('ec-noscroll');
  }

  function buildWhatsAppMessage(data) {
    var lines = cartLines();
    var msg = 'Hola ' + CFG.tienda + ', quiero confirmar y coordinar la entrega de mi pedido 🛍️\n\n';
    msg += '🧾 *Detalle del pedido:*\n';
    lines.forEach(function (l) {
      msg += '• ' + l.productTitle + (l.colorName ? ' — ' + l.colorName : '') + (l.talla ? ' (Talla ' + l.talla + ')' : '') + ' x' + l.qty + ' — ' + fmt(l.lineTotal) + '\n';
    });
    var savings = cartSavings();
    if (savings > 0) msg += '\n🎉 Ahorro por cantidad: ' + fmt(savings) + '\n';
    msg += '\n💰 *Total: ' + fmt(cartTotal()) + '*\n\n';
    msg += '👤 *Datos de entrega:*\n';
    msg += 'Nombre: ' + data.nombre + '\n';
    msg += 'DNI: ' + data.dni + '\n';
    msg += 'WhatsApp: ' + data.whatsapp + '\n';
    msg += 'Dirección: ' + data.direccion + '\n';
    if (data.referencia) msg += 'Referencia: ' + data.referencia + '\n';
    msg += 'Departamento: ' + data.departamento + '\n';
    msg += 'Provincia: ' + data.provincia + '\n';
    msg += 'Distrito: ' + data.distrito + '\n\n';
    msg += '📦 Quedo atento(a) a la confirmación y el costo de envío. ¡Gracias! 🙌';
    return msg;
  }

  function sendCheckout(e) {
    e.preventDefault();
    var form = e.target;
    var data = {
      nombre: form.nombre.value.trim(),
      dni: form.dni.value.trim(),
      whatsapp: form.whatsapp.value.trim(),
      direccion: form.direccion.value.trim(),
      referencia: form.referencia.value.trim(),
      departamento: form.departamento.value,
      provincia: form.provincia.value,
      distrito: form.distrito.value,
    };
    if (!data.nombre || !data.whatsapp || !data.direccion || !data.departamento || !data.provincia || !data.distrito) {
      alert('Por favor completa todos los campos obligatorios.');
      return;
    }
    if (!cartLines().length) { alert('Tu carrito está vacío.'); return; }
    var msg = buildWhatsAppMessage(data);
    var url = 'https://wa.me/' + CFG.whatsapp + '?text=' + encodeURIComponent(msg);
    window.open(url, '_blank');
    clearCart();
    closeShipping();
    form.reset();
  }

  /* ---------- Event delegation ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ec-action]');
    if (!btn) return;
    var action = btn.dataset.ecAction;
    var key = btn.dataset.key;
    if (action === 'open-cart') { openDrawer(); }
    else if (action === 'close-cart') { closeDrawer(); }
    else if (action === 'cart-inc') { var l = getCart().find(function (x) { return x.key === key; }); if (l) setLineQty(key, l.qty + 1); }
    else if (action === 'cart-dec') { var l2 = getCart().find(function (x) { return x.key === key; }); if (l2) setLineQty(key, l2.qty - 1); }
    else if (action === 'cart-remove') { removeLine(key); }
    else if (action === 'checkout') { openShipping(); }
    else if (action === 'close-shipping') { closeShipping(); }
  });

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'ec-shipping-form') { sendCheckout(e); }
  });

  document.addEventListener('DOMContentLoaded', function () {
    renderBadge();
    var form = el('ec-shipping-form');
    if (form) initUbigeoForm();
  });
  if (document.readyState !== 'loading') { renderBadge(); }

  window.ECCart = {
    addToCart: addToCart,
    openDrawer: openDrawer,
    openShipping: openShipping,
    getCart: getCart,
    cartLines: cartLines,
    cartTotal: cartTotal,
    cartUnitCount: cartUnitCount,
    tierFor: tierFor,
    fmt: fmt,
  };
})();
